import React from "react"
import { Box, Typography } from "@mui/material"

const Stepper = ({ pasoActual, isMobile }) => {
  const pasos = [
    { numero: 1, titulo: "Seleccionar evento" },
    { numero: 2, titulo: "Capturar rostro" },
    { numero: 3, titulo: "Confirmar" },
  ]

  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", position: "relative" }}>
      {/* Línea conectadora */}
      <Box
        sx={{
          position: "absolute",
          top: "15px",
          left: "10%",
          right: "10%",
          height: "2px",
          backgroundColor: "grey.300",
          zIndex: 1,
        }}
      />

      {pasos.map((paso, index) => (
        <Box
          key={paso.numero}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            zIndex: 2,
          }}
        >
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              backgroundColor: pasoActual >= paso.numero ? "primary.main" : "grey.300",
              color: pasoActual >= paso.numero ? "white" : "grey.500",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
              mb: 1,
            }}
          >
            {paso.numero}
          </Box>
          <Typography
            variant={isMobile ? "caption" : "body2"}
            sx={{
              fontWeight: pasoActual === paso.numero ? "bold" : "normal",
              textAlign: "center",
              maxWidth: isMobile ? 60 : 100,
            }}
          >
            {paso.titulo}
          </Typography>
        </Box>
      ))}
    </Box>
  )
}

export default Stepper
